import styled from "styled-components";
import DatePicker from "react-datepicker";


export const Button = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    border: 0;
    background: #626263;
    color: white;
    font-size: 1rem;
    font-weight: 400;
    cursor: pointer;
    margin-right: 5px;
    border-radius: 5px;
    transition: all .3s ease-in-out;
    user-select: none;

    :hover {
        background: var(--backgroundColorHover);
        transform: translateY(-3px);
    };

    :active {
        transform: scale(.9);
    };

    > i {
        font-size: 1.3rem;
        margin-right: 10px;
    }
    > span {
        margin: auto;
    }
`;

export const ButtonPadrao = styled.button`
    display: flex;
    justify-content: center;
    align-items: end;
    border: none;
    border-radius: 5px;
    padding: .5rem 1rem;
    margin: 0;
    text-decoration: none;
    background-color: var(--backgroundColorHover );
    color: var(--textBlack);
    font-size: 1rem;
    cursor: pointer;
    text-align: center;
    transition: background 250ms ease-in-out, transform 150ms ease;
    -webkit-appearance: none;
    -moz-appearance: none;
    transition: all .3s ease-in-out;
    user-select: none;

    :hover,:focus {
        background: #d8d8d8;
        transform: translateY(-3px);
    }

    :focus {
        outline: 1px solid #b1b1b1;
        outline-offset: -4px;
        outline-style: dashed;
    }

    :active {
        transform: scale(0.90);
    }
`;

export const ButtonPadraoPrimary = styled.button`
    user-select: none;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    border-radius: 5px;
    padding: .5rem 1rem;
    margin: 0;
    text-decoration: none;
    background-color: ${ props => props.cancel ? 'var(--cancelColor)' : 'var(--primaryColor)' };
    width:100%;
    max-width: 300px;
    color: #fff;
    font-weight: 400;
    font-size: 1rem;
    cursor: pointer;
    text-align: center;
    transition: background 250ms ease-in-out, transform 150ms ease;
    -webkit-appearance: none;
    -moz-appearance: none;

    transition: all .3s ease-in-out;

    :hover,:focus {
        background: ${ props => props.cancel ? 'var(--cancelColorHover)' : 'var(--primaryColorHover)' };
        transform: translateY(-3px);
    }

    :focus {
        outline: 1px solid #b1b1b1;
        outline-offset: -4px;
        outline-style: dashed;
    }

    :active {
        transform: scale(0.90);
    }

    :disabled {
        background: #a8c5ff;
        cursor: not-allowed;
    }
`;

export const ButtonTrue = styled.button`
    display: flex;
    align-items: center;
    justify-content: ace-betweensp;
    padding: 10px 20px;
    //border-radius: 4px;
    border: 0;
    background: #626263;
    color: white;
    font-size: 1rem;
    font-weight: 400;
    cursor: pointer;
    margin-right: 5px;

    &:hover {
        background-color: #3c3c3c;
    }
    > i {
        font-size: 1.3rem;
        margin-right: 10px;
    }
    > span {
        margin: auto;
    }
`;

export const IconButton = styled.button`
    display: "inline-block";
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-weight: bold;
    margin-left: 5px;

    > div {
        font-size: ${ props => props.configIconButton.fontSize || "20px" };
        color: ${ props => props.configIconButton.iconColor || "#a1a1a1" };
    }

    > div > span {
        margin-left: 5px;
    }

    &:hover {
        > div {
            color: #00515e;
        }
        > div > span {
            color: #00515e;
        }
    }
`;

export const ErrorLabel = styled.label`
    margin: 0 !important;
    color: red;
    font-style: italic;
    font-size: 12px;
`;

export const Title = styled.h1`
    color: var(--textBlack);
    font-size: 1.5rem;
`;

export const Span = styled.span`
    padding: 0 5px;
    white-space: normal;
    font-size: 14px;
    font-weight: 500;
    color: var(--textBlack);
`;

export const Label = styled.span`
    padding: 0 5px;
    white-space: normal;
    font-size: 14px;
    font-weight: 500;
    color: var(--textBlack);
`;

export const Input = styled.input`
    width: 100%;
    padding: 5px 10px;
    border-radius: 5px;
    border: 1px solid ${ props => props.invalido ? 'red' : '#d1d1d1' } ;
    box-shadow: ${ props => props.invalido ? '0px 0px 3px 0px rgb(235, 54, 54)' : 'none' } ;

    background: #fff;
    font-size: 14px;

    :focus {
        border: 1px solid #99d2ff;
        box-shadow: 0px 0px 3px 0px #99d2ff;
        background: var(--BackgroundColorInputs);
    }

    ::placeholder{
        font-weight:400;
    }

`;

export const InputDate = styled( DatePicker )`
    width: 100%;
    padding: 5px 10px;
    border-radius: 5px;
    border: 1px solid ${ props => props.invalido ? 'red' : 'var(--backgroundColorHover)' } ;
    box-shadow: ${ props => props.invalido ? '0px 0px 3px 0px rgb(235, 54, 54)' : 'none' } ;

    background: var(--backgroundColorHover);
    font-size: 14px;

    :focus {
        border: 1px solid #99d2ff;
        box-shadow: 0px 0px 3px 0px #99d2ff;
    }

    ::placeholder{
        font-weight:400;
    }
`;

export const Select = styled.select`
    width: 100%;
    padding: 5px 10px;
    border-radius: 5px;
    border: 1px solid ${ props => props.invalido ? 'red' : '#d1d1d1' } ;
    box-shadow: ${ props => props.invalido ? '0px 0px 3px 0px rgb(235, 54, 54)' : 'none' } ;

    background: #fff;
    font-size: 14px;

    :focus {
        border: 1px solid #99d2ff;
        box-shadow: 0px 0px 3px 0px #99d2ff;
    }

    ::placeholder{
        font-weight:400;
    }

`;

export const TextArea = styled.textarea`
    background: #fff;
    margin: 5px 0;
    height: 80px;
    border-radius: 4px;
    border: 1px solid ${ props => props.invalido ? 'red' : '#d1d1d1' } ;
    padding: 10px;
    margin: 5px 0;
    font-size: 14px;
    width: 100%;

    :focus{
        background: var(--BackgroundColorInputs);
        border: 1px solid #99d2ff;
        box-shadow: 0px 0px 3px 0px #99d2ff;
    }

    ::placeholder{
        font-weight:400;
    }
`;

export const InputCheck = styled.label`
    display: block;
    position: relative;
    padding-left: 30px;
    cursor: pointer;
    font-size: 14px;
    width: auto;
    user-select: none;

    > label {
        cursor: pointer;
        font-size: 14px;
        white-space: nowrap;
        font-size: 14px;
        font-weight: 500;
        color: var(--textBlack);
    }

    > input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    > span {
        position: absolute;
        top: 0;
        left: 0;
        height: 20px;
        width: 20px;
        background-color: #eee;
        transition: all .3s ease-in-out;
    }

    > input:checked ~ span {
        background-color: var(--primaryColor);
    }

    > span:after {
        content: "";
        position: absolute;
        display: none;

        left: 7px;
        top: 2px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    > input:checked ~ span:after {
        display: block;
    }

    > span:active {
        transform: scale(0.70);
    }
`;

export const InputRadio = styled.label`
    display: block;
    position: relative;
    padding-left: 20px;
    margin: 10px 20px 0px 0px;
    user-select: none;
    cursor: pointer;
    font-size: 14px;
    user-select: none;

    > label {
        cursor: pointer;
    }

    > input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }

    > input:checked ~ span {
        background-color: ${ props => props.colorChecked ? props.colorChecked : 'var(--primaryColor);' }
    }

    > span {
        position: absolute;
        top: 0;
        left: 0;
        height: 16px;
        width: 16px;
        background-color: #b7b7b7;
        border-radius: 50%;
    }

    > span:after {
        content: "";
        position: absolute;
        display: none;
    }

    > input:checked ~ span:after {
        display: block;
    }

    > span:after {
        top: 5px;
        left: 5px;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: white;
    }
`;

export const Header = styled.h3`
    color: var(--primaryColor);
    margin: 15px 0px;
    border-bottom: 1px solid;
`;

export const Group = styled.div`
    padding: 0px 10px;
`;

export const Form = styled.form`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const ContainerLine = styled.div`
    margin: 5px 0px;
    display: flex;
    flex-direction: column;
`;

export const GroupInLine = styled.div`
    display: flex;
    align-items: center;

    > div {
        width: 100%;
        margin-right: 10px;
    }
    div:last-child  {
        margin-right: 0px;
    }
`;

export const SpanErrorForm = styled.span`
    color: var(--cancelColorHover);
    margin-left: 5px;
    font-size: 12px;
    font-weight:600;
`;

export const SwitchContainer = styled.div`
    width: 51px;
    > .switch {
        display: none;
    }
    > .switch + label{
        display: block;
        position: relative;
        cursor: pointer;
        outline: none;
        user-select: none;
    }
    .switch--shadow + label {
        padding: 2px;
        width: 40px;
        height: 20px;
        background-color: var(--backgroundColorHover);
        border-radius: 30px;
    }
    .switch--shadow + label:before,
    .switch--shadow + label:after {
        display: block;
        position: absolute;
        top: 1px;
        left: 1px;
        bottom: 1px;
        content: "";
    }
    .switch--shadow + label:before {
        right: 1px;
        background-color: #f1f1f1;
        border-radius: 60px;
        transition: background 0.4s;
    }
    .switch--shadow + label:after {
        width: 20px;
        background-color: #fff;
        border-radius: 100%;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
        transition: all 0.4s;
    }
    .switch--shadow:checked + label:before {
        background-color: var(--primaryColor);
    }
    .switch--shadow:checked + label:after {
        transform: translateX(20px);
    }
`;

export const Table = styled.table`
    border-collapse: separate;
    border-spacing: 0;
    empty-cells: show;
    outline: 0;

    > thead tr th, > tbody tr td {
        padding: 15px 5px;
        text-align:left;
    }

    > thead tr th{
        border-bottom: 1px solid var(--backgroundColorHover);
        border-right: 1px solid var(--backgroundColorHover);
    }

    > tbody tr td{
        border-bottom: 1px solid var(--backgroundColorHover);
    }

    >tbody tr:nth-child(even) {
        background-color: var(--gerenalBackgroundColor);
    }

    > tbody tr:hover, >tbody tr:nth-child(even):hover  {
        cursor:pointer;
    }



`;
